<template>
  <div class="article__author flex flex-row items-center">
    <div class="flex flex-row flex-shrink-0">
      <OLink
        v-for="(author, i) in authorInformation"
        :key="i"
        pure
        :href="author.url"
        class="article-avatar inline-block overflow-hidden"
        v-bind="{ target: '_blank' }"
        @click="handleClickProfile()"
      >
        <OAvatar :src="author.image" :alt="author.name" class="w-11 h-11" :rounded="true" />
      </OLink>
    </div>
    <div class="flex-1 flex-col text-13 text-primary-200 font-medium ml-3 overflow-hidden">
      <div class="flex" :class="[isMobile ? 'flex-col' : 'flex-row']">
        <div v-for="(author, i) in authorInformation" :key="i" class="truncate">
          <span v-if="i > 0 && !isMobile" class="inline">,</span>
          <OLink
            pure
            :href="author.url"
            v-bind="{ target: '_blank' }"
            :class="[isOnedioVideo && !isMobile ? 'text-white' : '']"
            @click="
              // $analyticsEvent('User', 'User_Engagement', 'action_profile_click');
              handleClickProfile()
            "
          >
            {{ author.name || author.username || PASSIVE_USER }}
            <span class="font-normal">- {{ author.title }}</span>
          </OLink>
        </div>
      </div>
      <slot name="article_date"></slot>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';
import { isVideoArticle } from '../utils/articleUtils';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OAvatar, OLink } from '~/modules/common/components/ui';
import { useDevice } from '~/composables/useDevice';
import { getProfileUrl } from '~/modules/common/utils/routingUtils';
import { PASSIVE_USER } from '~/constants/site';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  components: {
    OAvatar,
    OLink,
  },
  props: {
    stn: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { sendDetayInteractionEvent } = onedioEvents();
    const article = inject('article');
    const isOnedioVideo = computed(() => isVideoArticle(article) && !props.stn);
    const { isMobile } = useDevice();
    const authorInformation = computed(() => {
      return article.authors.reduce((acc, author, index) => {
        if (index < 2) {
          acc.push({
            image: getImageUrl(author?.avatar, { width: 50 }),
            url: getProfileUrl({ user: author }),
            name: author?.name,
            username: author?.username,
            title: author?.title,
          });
        }
        return acc;
      }, []);
    });

    const handleClickProfile = (author) => {
      sendDetayInteractionEvent('Detay Sayfası', 'Click', 'Profile Git');
    };

    return { authorInformation, PASSIVE_USER, isOnedioVideo, isMobile, handleClickProfile };
  },
});
</script>

<style>
.article-avatar:not(:first-child) {
  margin-left: -10px;
}

.article-avatar:not(:first-child) img {
  -webkit-mask: radial-gradient(circle 24px at -10px 50%, transparent 99%, #fff 100%);
  mask: radial-gradient(circle 24px at -10px 50%, transparent 99%, #fff 100%);
}
</style>
